import { type RouteRecordRaw } from 'vue-router'

// No public routes - conversion cards marketing page is on www.owner.com
export const conversionCardsPublicRouter: RouteRecordRaw[] = []

// Brand-scoped dashboard (requires authentication)
export const conversionCardsBrandRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/ConversionCardsDashboardView.vue'),
    meta: {
      title: 'tools.conversion-cards',
    },
    name: 'brand.conversion-cards',
    path: 'conversion-cards',
  },
]
